import type { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';

import { EventLogInterface } from '@interface/logs/logs.interface';

export const eventLogsColumns: ColumnsType<EventLogInterface> = [
  {
    title: 'Time',
    dataIndex: 'occuredAt',
    key: 'occuredAt',
    render: (date) => dayjs(date).format('DD/MM/YYYY HH:mm'),
  },
  {
    title: 'Event ID',
    dataIndex: 'eventId',
    key: 'eventId',
  },
  {
    title: 'Event Type',
    dataIndex: 'eventType',
    key: 'eventType',
  },
  {
    title: 'Service',
    dataIndex: 'serviceId',
    key: 'serviceId',
  },
  {
    title: 'Unified Api',
    dataIndex: 'unifiedApi',
    key: 'unifiedApi',
  },
  {
    title: 'Entity Type',
    dataIndex: 'entityType',
    key: 'entityType',
  },
  {
    title: 'Entity ID',
    dataIndex: 'entityId',
    key: 'entityId',
  },
];
